module.exports = __webpack_public_path__ + "902cade2d1ab330a6d4fb7ce67f15c3e.png";


//////////////////
// WEBPACK FOOTER
// ./assets/images/patches/left_hand/calculator.png
// module id = 2989
// module chunks = 0